import { useAppSelector } from '@hooks/app/redux';
import { CheckmarkThickOutlined, EvisitOutlined } from '@icon';
import { Button, Tooltip } from '@ui';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import EVisitsWorkspaceSelector from '../e-visits-workspace-switcher';

interface EVisitExtraProps {
  canEdit?: boolean;
  toggleEvisitEdit?: () => void;
  isEditing?: boolean;
}

const EVisitExtra: React.FunctionComponent<EVisitExtraProps> = ({
  canEdit,
  toggleEvisitEdit,
  isEditing,
}) => {
  const { push } = useHistory();

  const selectedInstitution = useAppSelector((state) => state.eVisits.selectedInstitution);

  const onChange = React.useCallback((value?: { id: string } | null) => {
    if (value) {
      push(`/e-visits/calendar/${value.id}`);
    } else {
      push(`/e-visits/calendar`);
    }
  }, []);

  const disabled = !canEdit;
  const disabledEVisits = !selectedInstitution?.hasEvisit;

  const toggleButton = (
    <Button
      size="medium"
      block={false}
      variant="primary"
      Icon={isEditing ? CheckmarkThickOutlined : EvisitOutlined}
      disabled={disabledEVisits}
      onClick={() => toggleEvisitEdit?.()}
    >
      {isEditing ? (
        <FormattedMessage id="addForm_back_action" />
      ) : (
        <FormattedMessage id="eVisits_calendar_edit" />
      )}
    </Button>
  );

  return (
    <>
      <EVisitsWorkspaceSelector disabled={disabled} onChange={onChange} key="e-visits" />
      {disabledEVisits ? (
        <Tooltip content={'Musíte si povoliť e-Termín v nastaveniach poskytovateľa'}>
          <div>{toggleButton}</div>
        </Tooltip>
      ) : (
        toggleButton
      )}
    </>
  );
};

export default EVisitExtra;
